$(() => {
  const preselected = JSON.parse(localStorage.internalTrainingPreselection ?? '[]')

  $('.reserve-button').each(function () {
    const id = $(this).data('id')
    $(this).toggleClass('style-grey', preselected.includes(id))

    $(this).on('click', function () {
      if (preselected.includes(id)) {
        preselected.splice(preselected.indexOf(id), 1)
      } else {
        preselected.push(id)
      }

      localStorage.internalTrainingPreselection = JSON.stringify(preselected)
      $(this).toggleClass('style-grey')
    })
  })
})
